<template>
  <div>
    <div>
      <div class="card" v-show="infObjetivo">
        <div class="card-header">
          <center>
            <p class="titulo">Buscar Pacientes <i class="fa fa-user"></i></p>
          </center>
        </div>
        <br />
        <div class="card-body">
          <div class="container" v-show="buscar == true">
            <div class="col-md-4 col-12">
              <br />
              <select class="form-control" v-model="criterio">
                <option value="PacApe1">Apellidos del paciente</option>
                <option value="PacNom1">Nombre del paciente</option>
                <option value="PacNumDoc">Documento del paciente</option>
              </select>
            </div>
            <div class="col-md-4 col-12">
              <br />
              <input
                type="text"
                v-model="busqueda"
                @keyup.enter="buscarPacientes()"
                class="form-control"
              />
            </div>
            <div class="col-md-2">
              <br />
              <button
                style="border-radius: 5px"
                @click="buscarPacientes()"
                class="btn btn-success btn-fill"
              >
                Buscar <i class="fa fa-search"></i>
              </button>
            </div>
          </div>

          <div style="padding: 40px" v-show="buscar == false">
            <button class="btn btn-primary btn-sm btn-icon" @click="iniciar()">
              <i class="fa fa-refresh"></i>
            </button>
            <br />
            <center>
              <br />

              <div>
                <el-table
                  :data="arrayPacientes"
                  size="small"
                  style="width: 100%"
                  class="table-responsive table-striped"
                >
                  <!-- <el-table-column type="index"> </el-table-column> -->
                  <el-table-column prop="PacApe1" label="Apellidos">
                  </el-table-column>
                  <el-table-column prop="PacNom1" label="Nombres">
                  </el-table-column>
                  <el-table-column prop="PacNumDoc" label="N° documento">
                  </el-table-column>
                  <el-table-column width="80" label="">
                    <template slot-scope="props">
                      <a
                        class="btn btn-simple btn-sm btn-success"
                        @click="cargarAllObjetivos(props.row)"
                        ><i class="ti-eye"></i
                      ></a>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </center>
          </div>
          <center>
            <br /><br />
            <div class="" v-if="arrayPacientes == ''" style="width: 80%">
              <div class="alert alert-danger alert-with-icon">
                <center>
                  <img src="static/img/logo.webp" style="width: 20%" alt="" />
                  <br /><br />
                  <!-- <span data-notify="icon" class="fa fa-info"></span> -->
                  <strong data-notify="message" style="color: white">
                    <i :class="'fa fa-' + icono"></i> {{ mensaje }}
                  </strong>
                  <br /><br />
                </center>
              </div>
            </div>
          </center>
        </div>
        <br /><br />
        <div class="card-footer text-muted">
          <center>Avanza IPS</center>
        </div>
      </div>

      <div class="card" v-show="logros">
        <div class="card-header">
          <div class="row">
            <div class="col-md-5">
              <button class="btn btn-simple btn-icon" @click="volver()">
                <i
                  class="fa fa-arrow-circle-o-left"
                  style="font-size: 25px; color: #b3b3b3; float: right"
                ></i>
              </button>
            </div>
            <div class="col-md-5">
              <i class="fa fa-graduation-cap"></i> OBJETIVOS AVANZA
            </div>
            <div class="col-md-2">
            <br>
            <button @click="push('/historiaClinica/historia')"  class="btn btn-success btn-sm btn-fill" style="border-radius:5px;">Ir a la historia clinica</button>
          </div>
          </div>
        </div>
        <div>
          <br />

          <vue-tabs direction="horizontal" value="l">
            <v-tab title="Información General">
              <div class="row" style="margin: 1%">
                <div class="col-md-4">
                  <div class="card">
                    <div style="margin: 7%">
                      <!-- <img src="static/img/logo.png" style="width:80%;" alt="..."> -->
                    </div>
                    <div class="card-content">
                      <div class="author">
                        <img
                          class="border-white"
                          :src="foto"
                          style="width: 40%"
                          alt="..."
                        />
                        <h4 class="title">
                          {{ nombre }}
                          <br />
                          <small v-if="loked != null" ><strong class="text-danger">Confidencial</strong></small> <br>
                          <small>{{ fecha_nacimiento | date }}</small>
                        </h4>
                        <p class="title">Líderes</p>
                        <!-- <li> -->
                        <ul class="list-group">
                          <li class="list-group-item">
                            <p>
                              Fisioterapia: <strong>{{ tabs[0].lider }}</strong>
                            </p>
                            <p>
                              Fonoaudiología:
                              <strong>{{ tabs[1].lider }}</strong>
                            </p>
                            <p>
                              Ter. Ocupacional:
                              <strong>{{ tabs[2].lider }}</strong>
                            </p>
                            <p>
                              Psicología: <strong>{{ tabs[3].lider }}</strong>
                            </p>
                            <p>
                              Edu. Especial:
                              <strong>{{ tabs[4].lider }}</strong>
                            </p>
                          </li>
                        </ul>
                        <!-- </li> -->
                      </div>
                      <!-- <p class="description text-center">
                                  "I like the way you work it
                                  <br> No diggity
                                  <br> I wanna bag it up"
                                </p> -->
                    </div>
                    <hr />
                    <div class="text-center">
                      <div class="row"></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div
                    class="col-md-4 col-sm-6"
                    v-for="tab in tabs"
                    :key="tab.id"
                  >
                    <circle-chart-card
                      v-if="tab.id != 4 || tab.id == 4 && loked == null || loked == usuario || rol == 1 || rol == 9 || rol == 13"
                      :percentage="tab.promedio"
                      :pendiente="tab.pendiente"
                      :pendienteEvaluar="
                        tab.pendienteEvaluar > 0
                          ? tab.pendienteEvaluar + ' objetivo(s) por evaluar'
                          : ''
                      "
                      :bar="tab.bar"
                      :description="
                        tab.notification > 0
                          ? tab.notification + ' objetivo(s) por confirmar'
                          : ''
                      "
                      :title="tab.nombre"
                      :color="tab.color"
                    >
                    </circle-chart-card>
                    <circle-chart-card
                      v-else
                      :percentage="'--'"
                      
                      
                      :confidencial="true"
                      :title="'Psicología'"
                      :color="tab.color"
                    >
                    </circle-chart-card>
                  </div>
                </div>
              </div>
            </v-tab>
            <v-tab v-for="tab in tabs" :key="tab.id" :title="tab.nombre">
              <div class="row" style="padding:50px">
                <div class="col-md-2">
                  <button
                    class="btn btn-sm btn-fill btn-block btn-success"
                    style="border-radius: 5px"
                    v-if="
                      (tab.lider == usuario && estado == 1) ||
                      (rol == 1 && estado == 1)
                    "
                    :disabled="estado == 0"
                    @click="abrirModalRegistrar(tab)"
                    v
                  >
                    <i class="fa fa-plus"></i> Nuevo objetivo
                  </button>
                  <br>
                </div>
                <div class="col-md-6">
                  <strong
                    ><p>{{ tab.nombre }}</p></strong
                  >
                  <span v-if="estado == 0" style="color: red"
                    >Paciente Inactivo</span
                  >
                </div>
             
                <div class="col-md-12">
                  <el-table
                    
                    size="mini"
                    :data="tab.datos"
                    v-if="tab.id != 4 || tab.id == 4 && loked == null || loked == usuario || rol == 1 || rol == 9 || rol == 13"
                    class="table-responsive table-striped"
                  >
                    <el-table-column fixed="left" width="50">
                      <template slot-scope="props">
                        <i
                          class="fa fa-check"
                          style="color: green"
                          v-if="
                            props.row.updated_at <= props.row.ObjFecCum &&
                            props.row.ObjLog != null
                          "
                        ></i>
                        <i
                          class="fa fa-check"
                          style="color: orange"
                          v-if="
                            props.row.updated_at > props.row.ObjFecCum &&
                            props.row.ObjLog != null
                          "
                        ></i>
                        <i
                          class="fa fa-close"
                          style="color: red"
                          v-if="
                            props.row.ObjFecCum < fecha &&
                            props.row.ObjLog == null
                          "
                        ></i>
                      </template>
                    </el-table-column>
                    <el-table-column prop="ObjFec" label="Fecha" width="110">
                    </el-table-column>
                    <el-table-column
                      prop="ObjFecCum"
                      label="Fecha a cumplir"
                      width="125"
                    >
                    </el-table-column>
                    <el-table-column prop="ObjUsu" label="Terapeuta" width="90">
                    </el-table-column>
                    <el-table-column prop="ObjObj" label="Objetivo" fit>
                    </el-table-column>
                    <el-table-column label="Logro">
                      <template slot-scope="props">
                        <center>
                          <span
                            v-if="
                              fecha > props.row.ObjFecCum &&
                              props.row.ObjLog == null
                            "
                            >Logro en proceso de confirmación</span
                          >
                          <span v-else>{{ props.row.ObjLog }}</span>
                        </center>
                      </template>
                    </el-table-column>
                    <el-table-column label="Evidencia del logro" fit>
                      <template slot-scope="props">
                        
                          <a target="_blank" :href="props.row.UrlLogEvi" v-if="props.row.UrlLogEvi != null && props.row.UrlLogEvi != ''" 
                          class="btn btn-xs btn-fill"> <i class="fa fa-play"></i> Ver evidencia</a>
                      
                      </template>
                    </el-table-column>
                    <el-table-column label="Promedio" fit>
                      <template slot-scope="props">
                        <span>{{ props.row.ObjPor }} %</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Actions" width="200" fixed="right">
                      <template slot-scope="props">
                        <center>
                          <p>
                            <button
                              v-if="props.row.ObjLog == null && props.row.ObjUsu == terapeutaLog && props.row.ObjFec < '2025-03-09' ||  rol == 9 || rol == 13 || rol == 15 && props.row.ObjFec < '2024-01-15'"
                              @click="cargarObjetivo(props.row)"
                              class="btn btn-simple btn-icon btn-warning"
                            >
                              <i class="ti-pencil-alt"></i>
                            </button>

                            <!-- Nueva version -->
                            <span v-for="index in 3" :key="index">
                          <button
                            v-if="
                              props.row.ObjUsu == terapeutaLog && props.row.ObjFec > '2025-03-09' ||
                                rol == 9 ||
                                rol == 13 ||
                                rol == 15 && props.row.ObjFec > '2025-03-09'
                            "
                            @click="cargarObjetivoV2(props.row, index)"
                            class="btn btn-simple btn-icon btn-warning col"
                          >
                            <i class="ti-pencil-alt"></i>
                          </button>
                        </span>

                          </p>
                          <!-- <p v-else>{{ props.row.ObjPor }}%</p> -->

                          <!-- <button
                            v-if="props.row.ObjPor == 0 && rol == 1 || props.row.ObjPor == 0 && rol == 9 || props.row.ObjPor == 0 && rol == 13 || props.row.ObjPor == 0 && rol == 15"
                            @click="
                              prepararExtenderFecha(
                                props.row.ObjFecCum,
                                props.row.ObjIde
                              )
                            "
                            class="btn btn-icon btn-success btn-simple btn-sm"
                          >
                            <i class="fa fa-calendar"></i>
                          </button> -->
                        </center>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div v-else>
          <div class="row">
            <div class="col-md-12">
              <center>
                <br />
                <br />
                <img
                  src="static/img/ICONOS/candado.svg"
                  class="img-responsive"
                  width="70"
                  alt="Imagen de bloqueo de HC avanti"
                />
                <br />
                <span
                  >Estos Objetivos son confidenciales. Por favor comunicarse con el administrador para solicitar acceso.</span
                >
              </center>
            </div>
          </div>
        </div>
                  <br />
                </div>
            </div>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
    <!-- modales -->
    <!-- 
            primer modal-->
    <!-- <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :class="{ mostrar: modalRegistrar }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header CM" style="padding: 8px">
            <strong class="modal-title" id="exampleModalLongTitle">
              <i class="fa fa-graduation-cap"></i>
              Nuevo objetivo
            </strong>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label for>Fecha:</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="fecha"
              disabled
            />
            <label for>Fecha de cumplimiento</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="fechaCumplimiento"
            />
            <label for>Objetivo:</label>
            <textarea
              class="form-control form-control-sm"
              cols="30"
              v-model="objetivo"
              rows="4"
            ></textarea>
          </div>
          <center>
            <button
              v-show="fechaCumplimiento > fecha"
              type="button"
              @click="nuevoObjetivo()"
              class="btn btn-primary btn-sm"
            >
              Nuevo objetivo
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              @click="modalRegistrar = 0"
            >
              Cancelar
            </button>
          </center>
          <br />
        </div>
      </div>
    </div> -->
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      :class="{ mostrar: modalRegistrar }"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header CM" style="padding: 8px">
            <strong class="modal-title" id="exampleModalLongTitle">
              <i class="fa fa-graduation-cap"></i>
              Nuevo objetivo
            </strong>
          </div>
          <div class="modal-body">
            <!-- <label for>Fecha:</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="fecha"
              disabled
            />
            <label for>Fecha de cumplimiento:</label>
            <input
              type="date"
              class="form-control form-control-sm"
              v-model="fechaCumplimiento"
            /> -->
            <label for="objetivo">Objetivo:</label>
            <textarea
              id="objetivo"
              class="form-control form-control-sm"
              cols="30"
              v-model="objetivo"
              rows="8"
            ></textarea>
            <br />
            <span>Registra las tareas asociadas al objetivo</span>
            <br />
            <label for="logro1">Tarea 1:</label>
            <textarea
              id="logro1"
              class="form-control form-control-sm"
              cols="30"
              v-model="Log1"
              rows="4"
            ></textarea>

            <label for="logro2">Tarea 2:</label>
            <textarea
              id="logro2"
              class="form-control form-control-sm"
              cols="30"
              v-model="Log2"
              rows="4"
            ></textarea>

            <label for="logro1">Tarea 3:</label>
            <textarea
              id="logro3"
              class="form-control form-control-sm"
              cols="30"
              v-model="Log3"
              rows="4"
            ></textarea>
          </div>
          <center>
            <span style="color:red;" v-if="validarTareasIguales() == true">
              Las tareas no pueden coincidir.
            </span>
          </center>
          <center>
            <button
              type="button"
              style="border-radius: 5px"
              class="btn btn-danger"
              @click="modalRegistrar = 0"
            >
              Cancelar
            </button>
            <button
              v-show="
                  Log1 != '' &&
                  Log2 != '' &&
                  Log3 != '' &&
                  objetivo != '' &&
                  validarTareasIguales() != true
              "
              type="button"
              @click="nuevoObjetivo()"
              style="border-radius: 5px"
              class="btn btn-success btn-fill"
            >
              Nuevo objetivo
            </button>
          </center>
          <br />
        </div>
      </div>
    </div>
    <!-- fin primer modal -->
    <!-- segundo modal -->
    <!-- <div
      class="modal fade"
      :class="{ mostrar: modalCalificar }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header CM" style="padding: 8px">
            <strong class="modal-title" id="exampleModalLongTitle">
              <i class="fa fa-graduation-cap"></i> Nuevo Logro
            </strong>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label for>Calificación</label>
            <select class="form-control" v-model="puntaje">
              <option
                v-for="opcion in opciones"
                :key="opcion.id"
                :value="opcion.valor"
                v-text="opcion.texto"
              ></option>
            </select>
            <br />
            <label for>Evidencia del logro</label>
            <input for="" class="form-control" type="url" v-model="evidenciaRegistroLogro"/>
            <br />
            <label for>logro</label>
            <textarea
              v-model="logro"
              cols="30"
              rows="3"
              class="form-control"
            ></textarea>
            <br />
            <br />
            <center>
              <button
                class="btn btn-primary btn-sm"
                @click="calificarObjetivo()"
              >
                Evaluar
              </button>
              <button class="btn btn-danger btn-sm" @click="modalCalificar = 0">
                Cancelar
              </button>
            </center>
          </div>
          <center></center>
          <br />
        </div>
      </div>
    </div> -->
    <div
      class="modal fade"
      :class="{ mostrar: modalCalificar }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="height: 40vh !important">
          <div class="modal-header CM" style="padding: 8px">
            <strong class="modal-title" id="exampleModalLongTitle">
              <i class="fa fa-graduation-cap"></i> Avance de las tareas
            </strong>
            <!-- <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button> -->
          </div>
          <div class="modal-body">
            <div class="row" v-if="PeriodoCalificar === 1">
              <div class="col-sm-12">
                <p>{{ Log1 }}</p>
                <div class="input-group">
                  <select class="form-control" v-model="puntaje1" :disabled="bloquearBotonEvaluar">
                    <option value="" selected></option>
                    <option
                      v-for="opcion in opciones"
                      :key="opcion.id"
                      :value="opcion.valor"
                      v-text="opcion.texto"
                    ></option>
                  </select>
                  <span class="input-group-addon">{{ puntaje1 }}%</span>
                  <!-- <span class="input-group-addon">
                    <input
                      type="checkbox"
                      :disabled="puntaje1 == ''"
                      v-model="cumple1"
                    />
                  </span> -->
                </div>
              </div>
            </div>
            <br />

            <div class="row" v-if="PeriodoCalificar === 2">
              <div class="col-sm-12">
                <p>{{ Log2 }}</p>
                <div class="input-group">
                  <select class="form-control" v-model="puntaje2" :disabled="bloquearBotonEvaluar">
                    <option value="" selected></option>
                    <option
                      v-for="opcion in opciones"
                      :key="opcion.id"
                      :value="opcion.valor"
                      v-text="opcion.texto"
                    ></option>
                  </select>
                  <span class="input-group-addon">{{ puntaje2 }}%</span>
                  <!-- <span class="input-group-addon">
                    <input
                      type="checkbox"
                      :disabled="puntaje2 == ''"
                      v-model="cumple2"
                    />
                  </span> -->
                </div>
              </div>
            </div>
            <br />

            <div class="row" v-if="PeriodoCalificar === 3">
              <div class="col-sm-12">
                <p>{{ Log3 }}</p>
                <div class="input-group">
                  <select class="form-control" v-model="puntaje3" :disabled="bloquearBotonEvaluar">
                    <option value="" selected></option>
                    <option
                      v-for="opcion in opciones"
                      :key="opcion.id"
                      :value="opcion.valor"
                      v-text="opcion.texto"
                    ></option>
                  </select>
                  <span class="input-group-addon">{{ puntaje3 }}%</span>
                  <!-- <span class="input-group-addon">
                    <input
                      type="checkbox"
                      :disabled="puntaje3 == ''"
                      v-model="cumple3"
                    />
                  </span> -->
                </div>
              </div>
            </div>
            <br />

            <div class="row" v-if="PeriodoCalificar === 3">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >Comentarios del logro:</label
                  >
                  <textarea
                    :disabled="bloquearBotonEvaluar"
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="5"
                    v-model="comentario"
                    value="comentario"
                  ></textarea>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="linkEvidencia">Evidencia del logro:</label>
                  <input type="url" class="form-control" v-model="evidenciaRegistroLogro" :disabled="bloquearBotonEvaluar" />
                </div>
              </div>
            </div>
            <br />
            <br />

            <center>
              <button
                class="btn btn-danger"
                style="border-radius: 5px;"
                @click="modalCalificar = 0"
              >
                Cancelar
              </button>
              <button
                :disabled="bloquearBotonEvaluar"
                style="border-radius: 5px;"
                class="btn btn-success btn-fill"
                @click="calificarObjetivoV2()"
              >
                Evaluar
              </button>
            </center>
          </div>
          <center></center>
          <br />
        </div>
      </div>
    </div>
    <!-- fin segundo modal -->

    <!-- modal extender fecha de logro -->
    <modal name="modalextenderLogro" width="600" height="220">
      <div class="modal-header" style="padding: 7px">
        <div class="row">
          <div class="col-md-1">
            <i class="fa fa-calendar" style="font-size: 39px"></i>
          </div>
          <div class="col-md-7">
            <p class="titulo-modal">Extender fecha para el logro</p>
            <p class="texto-pequeno">
              Extender la fecha para registro de logro
            </p>
          </div>
        </div>
      </div>
      <div class="modal-body scroll-gg">
        <div class="row">
          <div class="col-md-12">
            <input
              v-model="fechaEdit"
              type="date"
              :min="fecha"
              class="form-control form-control-lg"
              style="background-color: white; height: 70px; font-size: 3.2vh"
            />
          </div>
          <div class="col-md-12">
            <br />
            <center>
              <button
                @click="editDate()"
                class="btn btn-success btn-block"
                style="border-radius: 0"
              >
                ACTUALIZAR FECHA
              </button>
            </center>
          </div>
        </div>
      </div>
    </modal>
    <!-- fin modal extender fecha logro -->
  </div>
</template>

<script>
import CircleChartCard from "src/components/UIComponents/Cards/CircleChartCard.vue";
import axiosInstance from "src/global-services/axiosInstance";
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import crearAlerta from "../../global-services/crearAlerta";
// import {Table, TableColumn} from 'element-ui'
import VueTabs from "vue-nav-tabs";

Vue.use(VueTabs);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  data() {
    return {
      terapeutaLog: localStorage.getItem("usuario"),
      opciones: [
        { texto: "Totalmente satisfactorio - 5", valor: 100, id: 0 },
        { texto: "Muy satisfactorio 4", valor: 80, id: 1 },
        {
          texto: "Satisfactorio - 3",
          valor: 60,
          id: 2,
        },
        {
          texto: "Poco satisfactorio - 2",
          valor: 40,
          id: 3,
        },
        {
          texto: "Nada satisfactorio - 1",
          valor: 20,
          id: 4,
        },
        // {
        //   texto: "No hubo logro - 0",
        //   valor: 0,
        //   id: 5,
        // },
      ],
      tabs: [
        {
          nombre: "Fisioterapia",
          id: "1",
          datos: [],
          promedio: 0,
          color: "blue",
          lider: "",
          bar: "#b8d8d8",
          notification: 0,
          pendiente: false,
          pendienteEvaluar: 0,
        },
        {
          nombre: "Fonoaudiología",
          id: "2",
          datos: [],
          promedio: 0,
          color: "orange",
          bar: "#ff8f5e",
          lider: "",
          notification: 0,
          pendiente: false,
          pendienteEvaluar: 0,
        },
        {
          nombre: "Ter. ocupacional",
          id: "3",
          datos: [],
          promedio: 0,
          color: "green",
          bar: "#d5e5a3",
          lider: "",
          notification: 0,
          pendiente: false,
          pendienteEvaluar: 0,
        },
        {
          nombre: "Psicología",
          id: "4",
          datos: [],
          promedio: 0,
          color: "brown",
          bar: "#d6c1ab",
          lider: "",
          notification: 0,
          pendiente: false,
        },
        {
          nombre: "Educación Especial",
          id: "5",
          datos: [],
          promedio: 0,
          color: "blue",
          bar: "#b8d8d8",
          lider: "",
          notification: 0,
          pendiente: false,
          pendienteEvaluar: 0,
        },
      ],
      buscar: true,
      controlContenido: 1,
      fecha: "",
      fechaCumplimiento: "",
      terapia: "",
      logro: "",
      foto: "",
      fecha_nacimiento: "",
      // contenido
      // fin contenido
      // BUSCAR PACIENTE
      tipoDocumento: 1,
      documentoBuscar: "",
      nombre: "",
      PacIde: "",
      fechaNacimiento: "",
      numeroDocumento: "",
      mostrarCalificar: false,
      ObjCalificar: "",
      puntaje: "",
      anos: 0,
      meses: 0,
      edad: "",
      objetivo: "",
      criterio: "PacApe1",
      busqueda: "",
      arrayPacientes: [],
      logros: false,
      infObjetivo: true,
      fechaEdit: "",
      idEdit: 0,
      // modales
      modalRegistrar: 0,
      tipoRegistro: 0,
      modalCalificar: 0,
      tituloModalCalificar: "",

      ip: "https://avanti-erp.com/",
      loked: null,
      token: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },
      icono: "bell",
      mensaje: "No hay datos de pacientes",
      usuario: "",
      rol: 0,
      estado: 0,
      evidenciaRegistroObjetivo: "",
      evidenciaRegistroLogro: "",

      // fin modales

      Log1: "",
      Log2: "",
      Log3: "",

      puntaje1: "",
      puntaje2: "",
      puntaje3: "",

      cumple1: "",
      cumple2: "",
      cumple3: "",

      bloquearBotonEvaluar: false,

      comentario: "",
      PeriodoCalificar: null,
    };
  },

  methods: {
    validarTareasIguales: function() {
      console.log(
        this.Log1 === this.Log2 ||
          this.Log1 === this.Log3 ||
          this.Log2 === this.Log3
      );
      return (
        this.Log1 === this.Log2 ||
        this.Log1 === this.Log3 ||
        this.Log2 === this.Log3
      );
    },
    abrirModalRegistrar(especialidad) {
      this.fechaCumplimiento = "";
      this.objetivo = "";
      this.modalRegistrar = 1;
      this.calcularFechaActual();
      this.tipoRegistro = especialidad.id;
      this.Log1 = "";
      this.Log2 = "";
      this.Log3 = "";
      this.objetivo = "";
      console.log(especialidad);
    },

    prepararExtenderFecha(date, id) {
      this.$modal.show("modalextenderLogro");
      this.fechaEdit = date;
      this.idEdit = id;
    },

    editDate: function () {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      const BASE_URL = `${this.ip}api/editDateObjetivo`;
      axios
        .post(
          BASE_URL,
          {
            id: this.idEdit,
            date: this.fechaEdit,
          },
          config
        )
        .then((res) => {
          if (res.data.status == true) {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: ` <div style="padding: 3%;">
              <span><b> ACTUALIZADO CON ÉXITO </b>.</span>
              </div>
              `,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type[color],
            });

            this.objetivosFisio();
            this.objetivosFono();
            this.objetivosTeo();
            this.objetivosPsi();
            this.objetivosEsp();
            this.$modal.hide("modalextenderLogro");
          }
        });
    },
    // nuevoObjetivo() {
    //   let config = {
    //     headers: {
    //       Authorization: "Bearer " + this.token,
    //     },
    //   };
    //   let vm = this;
    //   var url = this.ip + "api/nuevoObjetivo";
    //   axios
    //     .post(
    //       url,
    //       {
    //         PacIde: this.PacIde,
    //         fecha: this.fecha,
    //         objetivo: this.objetivo,
    //         fechaCumplir: this.fechaCumplimiento,
    //         evidencia: this.evidenciaRegistroObjetivo, 
    //         terapia: this.tipoRegistro,
    //         usuario: localStorage.getItem("usuario"),
    //         tipo: 1,
    //       },
    //       config
    //     )
    //     .then((response) => {
    //       var color = Math.floor(Math.random() * 4 + 1);
    //       this.$notify({
    //         component: {
    //           template: `<span>-<b> Objetivo registrado con éxito!</b>.</span>`,
    //         },
    //         icon: "ti-check",
    //         horizontalAlign: "right",
    //         verticalAlign: "top",
    //         type: this.type[color],
    //       });
    //       vm.modalRegistrar = 0;
    //       vm.fechaCumplimiento = "";
    //       vm.objetivo = "";
    //       if (vm.tipoRegistro == 1) {
    //         vm.objetivosFisio();
    //       }
    //       if (vm.tipoRegistro == 2) {
    //         vm.objetivosFono();
    //       }
    //       if (vm.tipoRegistro == 3) {
    //         vm.objetivosTeo();
    //       }
    //       if (vm.tipoRegistro == 4) {
    //         vm.objetivosPsi();
    //       }
    //       if (vm.tipoRegistro == 5) {
    //         vm.objetivosEsp();
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    nuevoObjetivo() {
      if (
        this.Log1 === this.Log2 ||
        this.Log1 === this.Log3 ||
        this.Log2 === this.Log3
      ) {
        this.$notify(
          crearAlerta("danger", "Las tareas no pueden ser las mismas")
        );
        return;
      }
      let config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      let vm = this;
      var url = this.ip + "api/nuevoObjetivoV2";
      axios
        .post(
          url,
          {
            PacIde: this.PacIde,
            fecha: this.fecha,
            objetivo: this.objetivo,
            Log1: this.Log1,
            Log2: this.Log2,
            Log3: this.Log3,
            fechaCumplir: this.obtenerUltimoDiaTrimestre(this.fecha),
            terapia: this.tipoRegistro,
            usuario: localStorage.getItem("usuario"),
            tipo: 1
          },
          config
        )
        .then(response => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: `<span>-<b> Objetivo registrado con éxito!</b>.</span>`
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color]
          });
          vm.modalRegistrar = 0;
          vm.fechaCumplimiento = "";
          vm.objetivo = "";
          vm.Log1 = "";
          vm.Log2 = "";
          vm.Log3 = "";
          if (vm.tipoRegistro == 1) {
            vm.objetivosFisio();
          }
          if (vm.tipoRegistro == 2) {
            vm.objetivosFono();
          }
          if (vm.tipoRegistro == 3) {
            vm.objetivosTeo();
          }
          if (vm.tipoRegistro == 4) {
            vm.objetivosPsi();
          }
          if (vm.tipoRegistro == 5) {
            vm.objetivosEsp();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    objetivosFisio() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      var url = this.ip + "api/objetivosFisio/" + this.PacIde + "/" + 1;
      let vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      axios
        .get(url, config)
        .then((response) => {
          vm.tabs[0].datos = response.data;
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }
              if (
                response.data[index].ObjFecCum > vm.fecha &&
                response.data[index].ObjLog == null
              ) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (
                response.data[index].ObjLog == null &&
                response.data[index].ObjFecCum < this.fecha
              ) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[0].pendiente = true;
              }
              var promedioFisio = suma / entre;
              parseInt(promedioFisio);
              var numero = promedioFisio.toFixed(0);
              if (isNaN(numero)) {
                vm.tabs[0].promedio = "--";
              } else {
                vm.tabs[0].promedio = parseInt(numero);
              }
            }
            vm.tabs[0].notification = pendienteConfirmar;
            vm.tabs[0].pendienteEvaluar = sinEvaluar;
          } else {
            vm.tabs[0].promedio = "--";
          }
          console.log(this.tabs[0], "tabs 0");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    objetivosFono() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      var url = this.ip + "api/objetivosFono/" + this.PacIde + "/" + 1;
      let vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      axios
        .get(url, config)
        .then(function (response) {
          vm.tabs[1].datos = response.data;
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }

              if (
                response.data[index].ObjFecCum > vm.fecha &&
                response.data[index].ObjLog == null
              ) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (
                response.data[index].ObjLog == null &&
                response.data[index].ObjFecCum < vm.fecha
              ) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[1].pendiente = true;
              }
              var promedioFono = suma / entre;
              parseInt(promedioFono);
              var numero = promedioFono.toFixed(0);
              if (isNaN(numero)) {
                vm.tabs[1].promedio = "--";
              } else {
                vm.tabs[1].promedio = parseInt(numero);
              }
            }
            vm.tabs[1].notification = pendienteConfirmar;
            vm.tabs[1].pendienteEvaluar = sinEvaluar;
          } else {
            vm.tabs[1].promedio = "--";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    objetivosTeo() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      var url = this.ip + "api/objetivosTeo/" + this.PacIde + "/" + 1;
      let vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      axios
        .get(url, config)
        .then((response) => {
          vm.tabs[2].datos = response.data;
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }

              if (
                response.data[index].ObjFecCum > vm.fecha &&
                response.data[index].ObjLog == null
              ) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (
                response.data[index].ObjLog == null &&
                response.data[index].ObjFecCum < this.fecha
              ) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[0].pendiente = true;
              }
              var promedioFono = suma / entre;
              parseInt(promedioFono);
              var numero = promedioFono.toFixed(1);
              if (isNaN(numero)) {
                vm.tabs[2].promedio = "--";
              } else {
                vm.tabs[2].promedio = parseInt(numero);
              }
            }
            vm.tabs[2].notification = pendienteConfirmar;
            vm.tabs[2].pendienteEvaluar = sinEvaluar;
          } else {
            vm.tabs[2].promedio = "--";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    objetivosPsi() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      var url = this.ip + "api/objetivosPsi/" + this.PacIde + "/" + 1;
      let vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      axios
        .get(url, config)
        .then((response) => {
          if(this.loked == null || this.loked == this.usuario || this.rol == 1 || this.rol == 9 || this.rol == 13){
            vm.tabs[3].datos = response.data;
          
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }
              if (
                response.data[index].ObjFecCum > vm.fecha &&
                response.data[index].ObjLog == null
              ) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (
                response.data[index].ObjLog == null &&
                response.data[index].ObjFecCum < this.fecha
              ) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[3].pendiente = true;
              }
              var promedioFono = suma / entre;
              parseInt(promedioFono);
              var numero = promedioFono.toFixed(1);
              if (isNaN(numero)) {
                vm.tabs[3].promedio = "--";
              } else {
                vm.tabs[3].promedio = parseInt(numero);
              }
            }
            vm.tabs[3].notification = pendienteConfirmar;
            vm.tabs[3].pendienteEvaluar = sinEvaluar;
          } else {
            vm.tabs[3].promedio = "--";
          }

          }else{
            vm.tabs[3].promedio = "--"
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    objetivosEsp() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      var url = this.ip + "api/objetivosEsp/" + this.PacIde + "/" + 1;
      let vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      axios
        .get(url, config)
        .then(function (response) {
          vm.tabs[4].datos = response.data;
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }
              if (
                response.data[index].ObjFecCum > vm.fecha &&
                response.data[index].ObjLog == null
              ) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (
                response.data[index].ObjLog == null &&
                response.data[index].ObjFecCum < this.fecha
              ) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[4].pendiente = true;
              }
              var promedioFono = suma / entre;
              parseInt(promedioFono);
              var numero = promedioFono.toFixed(1);
              if (isNaN(numero)) {
                vm.tabs[4].promedio = "--";
              } else {
                vm.tabs[4].promedio = parseInt(numero);
              }
              vm.tabs[4].notification = pendienteConfirmar;
              vm.tabs[4].pendienteEvaluar = sinEvaluar;
            }
          } else {
            vm.tabs[4].promedio = "--";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    buscarPacientes() {
      this.icono = "spinner";
      this.mensaje = "Cargando...";
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      this.arrayPacientes = [];
      let vm = this;
      var url =
        this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      axios
        .get(url, config)
        .then((response) => {
          this.icono = "bell";
          this.mensaje =
            "No hay resultados para su busqueda:  " + this.busqueda;
          vm.arrayPacientes = response.data.data;
          if(localStorage.getItem("PacienteHC")){
            this.cargarAllObjetivos(response.data.data[0])
          }
          if (response.data.data.length > 0) {
            vm.buscar = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    volver() {
      this.logros = false;
      this.infObjetivo = true;
      this.promedioFisio = 0;
      localStorage.removeItem('PacienteHC');
      localStorage.removeItem('PacienteId');
    },
    cargarAllObjetivos(paciente) {
      this.tabs[0].lider = paciente.t_fisio;
      this.tabs[1].lider = paciente.t_fono;
      this.tabs[2].lider = paciente.t_teo;
      this.tabs[3].lider = paciente.t_psico;
      this.tabs[4].lider = paciente.t_edu;
      this.PacIde = paciente.PacIdeUsu;
      this.loked = paciente.PacBlo;
      this.infObjetivo = false;
      this.estado = paciente.estado;
      this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
      this.foto = this.ip + "" + paciente.url_foto;
      this.fecha_nacimiento = paciente.PacFecNac;
      this.logros = true;
      localStorage.setItem('PacienteHC', paciente.PacNumDoc);
      localStorage.setItem('PacienteId', paciente.PacIdeUsu);
      localStorage.setItem('PacienteNombre', paciente.PacNom1 + ' ' + paciente.PacApe1)
      // console.log(paciente);
      setTimeout(() => {
        this.objetivosFisio();
        this.objetivosFono();
        this.objetivosTeo();
        this.objetivosPsi();
        this.objetivosEsp();
        this.calcularEdad();
      }, 1000);
    },

    cargarObjetivo(objetivo) {
      this.modalCalificar = 1;
      this.mostrarCalificar = true;
      this.ObjCalificar = objetivo.ObjIde;
    },
    async cargarObjetivoV2(objetivo, periodo) {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get(
          `api/obtener-logros-periodo/${objetivo.ObjIde}/${periodo}`
        );
        const logros = response.data.data;
        logros.forEach(element => {
          switch (element.id) {
            case 1:
              this.Log1 = element.description;
              this.puntaje1 =
                element.calificacion == null ? "" : element.calificacion;
              this.cumple1 = element.cumple;
              if(element.calificacion != null){
                this.bloquearBotonEvaluar = true;
              }else{
                this.bloquearBotonEvaluar = false;
              }
              break;
            case 2:
              this.Log2 = element.description;
              this.puntaje2 =
                element.calificacion == null ? "" : element.calificacion;
              this.cumple2 = element.cumple;
              if(element.calificacion != null){
                this.bloquearBotonEvaluar = true;
              }else{
                this.bloquearBotonEvaluar = false;
              }
              break;
            case 3:
              this.Log3 = element.description;
              this.puntaje3 =
                element.calificacion == null ? "" : element.calificacion;
              this.cumple3 = element.cumple;
              if(element.calificacion != null){
                this.bloquearBotonEvaluar = true;
              }else{
                this.bloquearBotonEvaluar = false;
              }
              this.comentario = objetivo.ObjLog;
              this.evidenciaRegistroLogro = objetivo.UrlLogEvi;
              break;
            default:
              console.warn(`ID de logro no esperado: ${element.id}`);
          }
        });
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.ObjCalificar = objetivo.ObjIde;
        this.PeriodoCalificar = periodo;
        this.modalCalificar = 1;
        this.$modal.hide("carga");
      }
    },
    calificarObjetivo() {
      if (this.logro == "") {
        alert("Es necesario registrar un logro");
      } else {
        let config = {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        };
        let vm = this;
        var url = this.ip + "api/calificar";
        axios
          .put(
            url,
            {
              objetivo: this.ObjCalificar,
              puntaje: this.puntaje,
              evidencia: this.evidenciaRegistroLogro,
              logro: this.logro,
            },
            config
          )
          .then((response) => {
            var color = Math.floor(Math.random() * 4 + 1);
            this.$notify({
              component: {
                template: `<span>-<b> Objetivo evaluado con éxito!</b>.</span>`,
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: this.type["success"],
            });
            vm.objetivosFisio();
            vm.objetivosFono();
            vm.objetivosTeo();
            vm.objetivosPsi();
            vm.objetivosEsp();
            vm.ObjCalificar = "";
            vm.puntaje = "";
            vm.logro = "";
            vm.modalCalificar = 0;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    async calificarObjetivoV2() {
      try {
        const periodo = this.PeriodoCalificar;
        const objetivo = this.ObjCalificar;
        const datos = {
          periodo: periodo,
          objetivo: objetivo,

          // logro 1
          puntaje1: this.puntaje1,
          cumple1: this.cumple1 == true ? 1 : 0,

          // logro 2
          puntaje2: this.puntaje2,
          cumple2: this.cumple2 == true ? 1 : 0,

          // logro 3
          puntaje3: this.puntaje3,
          cumple3: this.cumple3 == true ? 1 : 0,
          comentario: this.comentario,

          evidencia: this.evidenciaRegistroLogro,
        };
        this.$modal.show("carga");
        const response = await axiosInstance.post(
          `api/calificar-logros-periodo`,
          datos
        );

        if (response.data.status === true) {
          this.$notify(crearAlerta("success", "Periodo evaluado con éxito"));
        }
      } catch (error) {
        console.log("Error al obtener los datos:" + error);
      } finally {
        this.ObjCalificar = null;
        this.PeriodoCalificar = null;
        this.modalCalificar = 0;
        this.$modal.hide("carga");
        window.location.reload();
      }
    },

    calcularEdad() {
      if (this.fechaNacimiento != "") {
        var fechaNacimiento = this.fechaNacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        // this.fechaIngreso = fechaActual;

        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        // calculamos los meses
        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        // calculamos los dias
        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
      // this.calcularFechaActual();
    },
    calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fecha = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fecha = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    iniciar() {
      this.mensaje = "No hay datos de pacientes";
      this.buscar = true;
      this.arrayPacientes = [];
      this.busqueda = "";
    },
    alerta()  {
      let opcion = confirm(`¿desea continuar viendo los objetivos de ${localStorage.getItem('PacienteNombre')}?`);
      if (opcion == true) {
        this.criterio = 'PacNumDoc';
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC")
        localStorage.removeItem("PacienteId")
        localStorage.removeItem("PacienteNombre")
      }
      
    },
    obtenerUltimoDiaTrimestre(fecha) {
      fecha = new Date(fecha);
      const year = fecha.getFullYear();
      const trimestre = Math.ceil((fecha.getMonth() + 1) / 3); // Determina el trimestre (1-4)

      // Últimos días de cada trimestre
      const ultimoDiaPorTrimestre = [31, 30, 30, 31];
      const ultimoMesTrimestre = trimestre * 3 - 1; // Mes final del trimestre (0-indexado)

      const ultimoDia = new Date(
        year,
        ultimoMesTrimestre,
        ultimoDiaPorTrimestre[trimestre - 1]
      );
      return ultimoDia.toISOString().split("T")[0];
    },
    push(route){
      this.$router.push(route);
    }
  },
  components: {
    CircleChartCard,
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.token = localStorage.getItem("token");
      this.usuario = localStorage.getItem("usuario");
      this.rol = localStorage.getItem("rol");
      this.calcularFechaActual();
      if(localStorage.getItem("PacienteHC")){
        this.alerta();
      }
    }
  },
};
</script>
<style scoped> 
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  /* position: absolute !important; */
  background-color: #3c29297a;
  padding-top: 10%;
}
.modal-content {
  width: 100% !important;
  position: relative !important;
  overflow-y: scroll;
  height: 85vh;
}

.modal-content2 {
  width: 100% !important;
  position: relative !important;
  overflow-y: scroll;
  height: 30vh;
}

.tabs {
  cursor: pointer;
}
.titulo {
  font-size: 20px;
}

.scroll-gg {
  width: 100%;
  height: 400px;
  overflow: auto;
}

.texto-pequeno {
  font-size: 12px;
  color: darkgray;
  padding: 0px !important;
  margin: 0px !important;
}

.titulo-modal {
  padding: 0px !important;
  margin: 0px !important;
}

p.description {
  font-size: 12px !important;
  color: grey !important;
}

p.pendienteEvaluar {
  font-size: 12px !important;
  color: grey !important;
}

.card-circle-chart {
  height: 330px !important;
  max-height: 330px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Diario-De-Campo/objetivos-logros.vue